import { Box } from "@mui/material";
import { useState } from "react";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { setupManagementUrl } from "../../../config";
import SizeForm from "./Form";
import { SizeQuery } from "../../../data/Axios/queries";

const base_url = setupManagementUrl.uri;

const actions = {
  entity: "Size",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "sizeIds",
    inputObjectName: "bulkActivateDeactivateSizes",
  },
  showStatus: true,
};

function SizeTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  return (
    <Box m="2px">
      <DynamicTable
        title="Shoe Sizes"
        subtitle="Manage shoe sizes"
        FormComponent={SizeForm}
        query={SizeQuery}
        base_url={base_url}
        actions={actions}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
      />
    </Box>
  );
}

export default SizeTable;
